<template>
  <div  class="mainImageLib myScrollArea">

<!--    <div v-if="step === 1 || step === 4 || step === 5 || step === 6" style="position:relative;z-index:15;" class="pt-4 pl-4">-->
<!--      <v-text-field v-model="search_keyword" @focus="searchInputFocus" @blur="searchInputBlur" @keyup.enter.native="searchInputEnter"-->
<!--                    id="keywordInputArea" autocomplete="off" dense outlined placeholder="搜索影像内容" dark hide-details color="#ffffff" style="width:308px;background:#2a2a2a;">-->
<!--        <template v-slot:append>-->
<!--          <p @click="searchBtnClick" style="font-size:16px;font-weight:bold;color:#ffffff;cursor:pointer;" class="iconfontFamily mt-1">&#xe630;</p>-->
<!--        </template>-->
<!--      </v-text-field>-->
<!--      <div @click="clearSearchKeyword" v-if="search_keyword!==''" style="position:absolute;top:28px;right:55px;width:16px;height:16px;cursor:pointer;">-->
<!--        <p style="line-height:16px;font-size:16px;color:#c4c4c4;" class="iconfontFamily">&#xe632;</p>-->
<!--      </div>-->

<!--      <div v-show="search_resultAreaShow" style="position:absolute;top:58px;left:16px;width:308px;background:#2a2a2a;border-radius:2px;padding:0 16px;">-->

<!--        &lt;!&ndash;历史记录&ndash;&gt;-->
<!--        <div v-show="search_resultAreaHistoryShow && search_history.length !== 0" style="margin:7px 0;">-->
<!--          <div @click="clickSearchHistory(item)" v-for="(item,index) in search_history" :key="'searchHistory'+index" style="min-height:35px;font-size:14px;color:#ffffff;cursor:pointer;display:flex;">-->
<!--            <p style="line-height:35px;" class="iconfontFamily mr-4">&#xe63f;</p>-->
<!--            <p style="line-height:35px;">-->
<!--              {{item}}-->
<!--            </p>-->
<!--          </div>-->

<!--          <div @click="clearSearchHistory" style="text-align:center;color:#A6A6A6;font-size:14px;cursor:pointer;">-->
<!--            <p style="line-height:31px;">清空历史记录</p>-->
<!--          </div>-->

<!--        </div>-->

<!--        &lt;!&ndash;联想结果&ndash;&gt;-->
<!--        <div v-show="search_resultAreaAssociativeShow && search_associative.length !== 0" style="margin:7px 0;">-->
<!--          <div @click="clickSearchResult(item)" v-for="(item,index) in search_associative" :key="'searchAssociative'+index" style="min-height:35px;font-size:14px;color:#ffffff;cursor:pointer;display:flex;">-->
<!--            <p style="line-height:35px;" class="iconfontFamily mr-4">&#xe630;</p>-->
<!--            <p style="line-height:35px;">-->
<!--              {{item}}-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->



<!--      </div>-->
<!--    </div>-->



    <!--第一层 初始列表-->
    <div v-if="step===1" style="margin-left:15px;" class="pt-4 pb-4">

      <div v-if="step1_imageFolderList.length !== 0" @click="intoStep2" :style="{'background-image':'url(' + step1_imageFolderList[0].picture + ')'}"
           class="domesticFolder">

        <!--hover蒙层-->
        <div class="domesticFolderHoverMantle domesticFolderHoverShow" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;height:100%;background:rgba(0, 0, 0, 0.4);border-radius:6px;"></div>

        <div class="domesticFolder-title">
<!--          <v-img src="../../../assets/globe/image_lib/folderIcon.png" style="width:21px;margin-top:8px;float:left;"></v-img>-->
          <p style="width:calc(100% - 30px);overflow: hidden;text-overflow:ellipsis;white-space: nowrap;float:left;font-size:16px;color:#ffffff;font-weight:bold;text-shadow: -1px 1px 0 #000, 1px 1px 0 #000, 1px -1px 0 #000,-1px -1px 0 #000;">{{step1_imageFolderList[0].labelName}}</p>
        </div>

        <!--hover说明文字-->
        <div class="domesticFolderHoverShow" style="position:absolute;bottom:4px;left:0;right:0;width:100%;height:17px;padding:0 10px;font-size:14px;color:#ffffff;">
          <p style="line-height:17px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;" class="ma-0">{{step1_imageFolderList[0].remark}}</p>
        </div>

      </div>

<!--      <div style="width:308px;height:1px;background:#a6a6a6;margin:15px 0;"></div>-->

      <div v-if="step1_imageFolderList.length > 1" style="margin-top:16px;">
        <div @click="intoStep3(item)" v-for="(item,index) in step1_imageFolderList.slice(1,step1_imageFolderList.length)" :key="index"
             :style="{'margin-left':index % 2 === 1 ? '16px' : '0'}" style="margin-bottom:12px;display:inline-block;">
          <image-folder :thumb="item.picture" :title="item.labelName" :contentNum="item.collectionCount" :remark="item.remark"></image-folder>
        </div>
      </div>


      <div style="width:308px;height:1px;background:#a6a6a6;margin:7px 0 15px 0;"></div>

      <p style="font-size:16px;color:#ffffff;">影像推荐</p>

      <div @click="intoStep4(item)" v-for="(item,index) in step1_imageTypeFolderList" :key="'imageTypeFolder'+index" style="margin-top:15px;">
        <image-type-folder :background="item.picture" :title="item.typeName"></image-type-folder>
      </div>
    </div>


    <!--第二层  仅中国有第二层省份-->
    <div v-if="step === 2">
      <div :style="{'background-image':'url(' + this.step1_imageFolderList[0].picture + ')'}" style="width:100%;height:174px;background-size:cover;background-position: center;">

        <div style="height:46px;background: linear-gradient(rgba(0, 0, 0, 0.5) 0%,rgba(122, 122, 122, 0) 76.75% ,rgba(255, 255, 255, 0) 100%);">
          <p style="margin:0 15px;line-height:46px;color:#ffffff;font-size:16px;display:flex;">
          <span @click="backStep1" style="font-weight:550;cursor:pointer;">
            <span class="iconfontFamily">&#xe617;</span>
            返回
          </span>
            <v-spacer></v-spacer>
            <span style="width:200px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;text-align:right;font-weight:550;">全部/中国</span>
          </p>

        </div>


      </div>

      <div style="margin-left:15px;margin-top:17px;" class="pb-2">
        <div @click="intoStep3(item)" v-for="(item,index) in step2_imageFolderList" :key="index"
             :style="{'margin-left':index % 2 === 1 ? '16px' : '0'}" style="margin-bottom:12px;display:inline-block;">
          <image-folder :thumb="item.picture" :title="item.labelName" :contentNum="item.collectionCount" :remark="item.remark"></image-folder>
        </div>
      </div>

    </div>

    <!--第三层 事件层-->
    <div v-if="step === 3">
      <div :style="{'background-image':'url(' + step3_topBackground + ')'}" style="width:100%;height:174px;background-size:cover;background-position: center;">
        <div style="height:46px;background: linear-gradient(rgba(0, 0, 0, 0.5) 0%,rgba(122, 122, 122, 0) 76.75% ,rgba(255, 255, 255, 0) 100%);">
          <p style="margin:0 15px;line-height:46px;color:#ffffff;font-size:16px;display:flex;">
          <span @click="backStep1Or2" style="font-weight:550;cursor:pointer;">
            <span class="iconfontFamily">&#xe617;</span>
            返回
          </span>
            <v-spacer></v-spacer>
            <span style="width:200px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;text-align:right;font-weight:550;">全部/{{step3_topLevelName}}</span>
          </p>
        </div>


      </div>

      <div style="margin-left:15px;" class="pb-2">
<!--        <p v-show="step3_province!==''" style="font-size:12px;color:#a6a6a6;" class="mt-4">区域省份：{{step3_province}}</p>-->
        <div v-for="(item,index) in step3_imageItemList" :key="index">
          <p @click="item.closeStatus = !item.closeStatus" :style="{'margin-top':index === 0 ? '16px' : '12px'}" class="mb-3" style="font-size:16px;color:#ffffff;cursor:pointer;">
            <span style="margin-right:6px;color:#a6a6a6;" class="iconfontFamily">{{item.closeStatus ? "&#xe65c;" : "&#xe645;"}}</span>
            {{item.type}} ({{item.zImageCollectionList.length}})
          </p>
          <div v-show="!item.closeStatus">
              <image-item v-for="(imageItem,imageIndex) in item.zImageCollectionList" :key="'imageItem'+imageIndex" @showImagePreview="showImagePreview"
                          :info="imageItem" :showPreview="imageItem.mainId === previewImageId"
                          :style="{'margin-left':imageIndex % 2 === 1 ? '16px' : '0'}" style="margin-bottom:12px;display:inline-block;">
              </image-item>

          </div>
        </div>
      </div>

    </div>

    <!--第四层 同一类别事件层-->
    <div v-if="step === 4" style="position:relative;height:calc(100% - 56px);">
      <p style="padding:0 15px;margin-bottom:2px !important;line-height:46px;color:#ffffff;font-size:16px;display:flex;">
          <span @click="backStep1" style="cursor:pointer;">
            <span class="iconfontFamily">&#xe617;</span>
            返回
          </span>
        <v-spacer></v-spacer>
        <span style="font-size:14px;color:#A6A6A6;">主题：{{step4_type.typeName}}</span>
      </p>
      <div class="pb-2" style="height:calc(100% - 69px);margin-left:15px;">
        <image-item v-for="(item,index) in step4_imageItemList" :key="'imageItem'+index" @showImagePreview="showImagePreview"
                    :info="item" :showPreview="item.mainId === previewImageId"
                    :style="{'margin-left':index % 2 === 1 ? '16px' : '0'}" style="margin-bottom:12px;display:inline-block;">
        </image-item>

        <div v-if="step4_imageItemList.length === 0" style="position:relative;top:50%;transform:translate(0,-70%);text-align:center;">
          <p style="font-size:66px;color:#808080;" class="iconfontFamily">&#xe647;</p>
          <p style="position:relative;top:50%;color:#a6a6a6;">暂无相关影像</p>
        </div>

      </div>

    </div>

    <!--第五层 搜索中-->
    <div v-if="step === 5" style="position:relative;height:calc(100% - 56px);text-align:center;color:#ffffff;">
      <p style="position:relative;top:50%;">搜索中······</p>
    </div>

    <!--第六层 搜索结果-->
    <div v-if="step === 6" style="position:relative;height:calc(100% - 56px);">
      <p style="padding:0 15px;margin-bottom:15px !important;line-height:46px;color:#ffffff;font-size:16px;border-bottom:2px solid rgba(0,0,0,0.15);display:flex;">
          <span @click="backSearchOldStep" style="cursor:pointer;">
            <span class="iconfontFamily">&#xe617;</span>
            返回
          </span>
        <v-spacer></v-spacer>
        <span style="font-size:14px;color:#A6A6A6;">共{{search_resultNum}}个结果</span>
      </p>
      <div class="pb-2" style="height:calc(100% - 69px);margin-left:15px;">
        <div v-for="(item,index) in search_imageItemList" :key="index">
          <p @click="item.closeStatus = !item.closeStatus" :style="{'margin-top':index === 0 ? '20px' : '12px'}" class="mb-5" style="font-size:16px;color:#ffffff;cursor:pointer;">
            <span style="margin-right:6px;color:#a6a6a6;" class="iconfontFamily">{{item.closeStatus ? "&#xe644;" : "&#xe645;"}}</span>
            {{item.type}} ({{item.zImageCollectionList.length}})
          </p>
          <div v-show="!item.closeStatus">
            <image-item v-for="(imageItem,imageIndex) in item.zImageCollectionList" :key="'imageItem'+imageIndex" @showImagePreview="showImagePreview"
                        :info="imageItem" :showPreview="imageItem.mainId === previewImageId"
                        :style="{'margin-left':imageIndex % 2 === 1 ? '16px' : '0'}" style="margin-bottom:12px;display:inline-block;">
            </image-item>
          </div>
        </div>

        <div v-if="search_resultNum === 0" style="position:relative;top:50%;transform:translate(0,-70%);text-align:center;">
          <p style="font-size:66px;color:#808080;" class="iconfontFamily">&#xe647;</p>
          <p style="position:relative;top:50%;color:#a6a6a6;">暂无相关影像</p>
        </div>

      </div>

    </div>




  </div>

</template>

<script>
import * as turf from '@turf/turf'

import ImageFolder from '../components/ImageFolder';
import ImageTypeFolder from '../components/ImageTypeFolder';
import ImageItem from '../components/ImageItem';

export default {
  name: "MainSearch",
  components:{ImageFolder,ImageTypeFolder,ImageItem},
  props:["previewImageId"],
  data(){
    return{

      //列表在第几层。1初始，2中国省份，3事件，4根据类型进入的事件，5搜索中，6搜索结果
      step:1,


      search_keyword:"",
      search_resultAreaShow:false,
      search_resultAreaHistoryShow:false,
      search_resultAreaAssociativeShow:false,
      search_history:[],
      search_associative:[],

      searchKeywordChange_getHistory:true,   //搜索关键字变化为空时，是否展示搜索历史，仅特殊情况下为false

      search_oldStep:0,

      searching:false,


      //第一层
      //文件夹列表
      step1_imageFolderList:[],
      //四类类型
      step1_imageTypeFolderList:[],


      //第二层
      //文件夹列表
      step2_imageFolderList:[],


      //第三层
      step3_topBackground:"",
      step3_province:"",
      step3_topLevelName:"",
      //事件列表
      step3_imageItemList:[],


      //第四层
      step4_type:"",
      step4_imageItemList:[],
      step4_currPageNum:1,
      step4_totalPageNum:0,



      //第六层，搜索结果事件列表
      search_imageItemList:[],




    }


  },

  computed:{
    search_resultNum(){
      let num = 0;
      for(let i=0;i<this.search_imageItemList.length;i++){
        for(let j=0;j<this.search_imageItemList[i].zImageCollectionList.length;j++){
          num ++;
        }
      }
      return num;
    }

  },
  watch:{
    //搜索栏输入变化
    search_keyword(){
      if(this.search_keyword != null && this.search_keyword !== ""){
        if(this.searching){
          //搜索中
          this.search_resultAreaShow = false;
        }
        else{
          //联想搜索词
          this.$axios({
            method:"get",
            url:"/authorApi/z-image-collection/getMoreByKeyWord",
            params:{
              keyWord:this.search_keyword
            }
          }).then((resultData)=>{
            resultData = resultData.data;
            if(resultData.status === 200){
              this.search_associative = resultData.data;
              this.search_resultAreaShow = true;
              this.search_resultAreaHistoryShow = false;
              this.search_resultAreaAssociativeShow = true;
            }
            else{
              console.log(resultData.status + resultData.message);
            }
          }).catch((err)=>{
            console.log(err);
          });

        }

      }
      else{
        //展示历史记录
        if(this.searchKeywordChange_getHistory){
          this.getSearchHistory();
        }
        else{
          this.searchKeywordChange_getHistory = true;
        }

      }

    },

    //监听是否展示搜索结果，判断是否显示地球蒙层
    search_resultAreaShow() {
      if(this.search_resultAreaShow){
        this.$parent.transparentMantle = true;
      }
      else{
        this.$parent.transparentMantle = false;
      }
    },

    //进入第四层时，增加滚动条滑动到底加载新一页
    //step切换时，滚动条回到顶部
    step(){
      document.getElementsByClassName("mainImageLib")[0].scrollTop = 0;
      if(this.step === 4){
        setTimeout(()=>{
          document.getElementsByClassName("mainImageLib")[0].addEventListener('scroll', this.scrollToBottom);
        },100)

      }
      else{
        document.getElementsByClassName("mainImageLib")[0].removeEventListener('scroll', this.scrollToBottom);
      }

    }

  },

  methods:{

    //获取首层列表
    getStepOneList(){
      this.$axios({
        method:"get",
        url:"/authorApi/z-location-label/getFirstLableList",
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.step1_imageFolderList = resultData.data;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },

    //获取首层类型列表
    getStepOneImageTypeList(){
      this.$axios({
        method:"get",
        url:"/authorApi/z-image-collection-type/getList",
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.step1_imageTypeFolderList = resultData.data
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },



    //国内影像，进入第二层
    intoStep2(){
      this.$axios({
        method:"get",
        url:"/authorApi/z-location-label/getSecondLableList",
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.step2_imageFolderList = resultData.data;
          this.showFolderMarker(this.step2_imageFolderList,120)

          this.step = 2;

          let bounds = [JSON.parse(this.step1_imageFolderList[0].geo).coordinates[0][0], JSON.parse(this.step1_imageFolderList[0].geo).coordinates[0][2]]
          this.$parent.map.fitBounds(bounds)
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });
    },

    //返回第一层
    backStep1(){
      this.step = 1;
      this.showFolderMarker(this.step1_imageFolderList,130)
      //可能处于预览状态
      this.$emit("quitPreviewLeftBar");

      this.$parent.map.flyTo({
        center:this.$parent.initCenter,
        zoom:this.$parent.initZoom,
        bearing:0,
        pitch:0
      })
    },


    //进入第三层事件层，中国的第二层/国外的第一层
    intoStep3(folderItem){
      this.$axios({
        method:"get",
        url:"/authorApi/z-image-collection/getListByLabel",
        params:{
          label:folderItem.labelName
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.step3_topBackground = folderItem.picture;
          this.step3_province = folderItem.province;

          //列表值
          this.step3_imageItemList = resultData.data;
          for(let i=0;i<this.step3_imageItemList.length;i++){
            this.$set(this.step3_imageItemList[i],"closeStatus",false)
          }

          //层次变化
          if(this.step === 1){
            //国外
            this.step3_topLevelName = folderItem.labelName
            this.step = 3;
          }
          else if(this.step === 2){
            //国内
            this.step3_topLevelName = "中国/" + folderItem.labelName
            this.step = 3;
          }

          //球上展示标签
          let imageMarkerList = [];
          for(let i=0;i<this.step3_imageItemList.length;i++){
            for(let j=0;j<this.step3_imageItemList[i].zImageCollectionList.length;j++){
              imageMarkerList.push(this.step3_imageItemList[i].zImageCollectionList[j])
            }
          }
          this.showImageMarker(imageMarkerList)

          //获取MultiPolygon的外接矩形
          var bbox = turf.bbox(JSON.parse(folderItem.geo))
          let bounds = [[bbox[0],bbox[1]],[bbox[2],bbox[3]]]
          this.$parent.map.fitBounds(bounds)

        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },


    //事件层返回第一层（国外）/第二层（国内）
    backStep1Or2(){
      if(this.step3_topLevelName.indexOf("中国/") !== -1){
        //中国的事件，回到第二层
        this.step = 2;
        this.showFolderMarker(this.step2_imageFolderList,120)
        //可能处于预览状态
        this.$emit("quitPreviewLeftBar");

        let bounds = [JSON.parse(this.step1_imageFolderList[0].geo).coordinates[0][0], JSON.parse(this.step1_imageFolderList[0].geo).coordinates[0][2]]
        this.$parent.map.fitBounds(bounds)
      }
      else{
        //国外的事件，回到第一层
        this.step = 1;
        this.showFolderMarker(this.step1_imageFolderList,130)
        //可能处于预览状态
        this.$emit("quitPreviewLeftBar");

        this.$parent.map.flyTo({
          center:this.$parent.initCenter,
          zoom:this.$parent.initZoom,
          bearing:0,
          pitch:0
        })
      }

    },


    //从类型 进入第四层
    intoStep4(typeItem){

      document.getElementsByClassName("mainImageLib")[0].scrollTop = 0

      this.step4_currPageNum = 1;
      this.$axios({
        method:"get",
        url:"/authorApi/z-image-collection/getListByType",
        params:{
          type:typeItem.typeId,
          curPageNum:this.step4_currPageNum,
          maxResultNum:10,
          keyWord:this.search_keyword,
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){

          this.step4_imageItemList = resultData.data.list
          this.step4_totalPageNum = resultData.data.totalPageNum

          this.step4_type = typeItem;
          this.step = 4;
          this.showImageMarker(this.step4_imageItemList)

          //可能处于预览状态
          this.$emit("quitPreviewLeftBar");
          this.$parent.map.flyTo({
            center:this.$parent.initCenter,
            zoom:this.$parent.initZoom,
            bearing:0,
            pitch:0
          })
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },




    //搜索

    // //获取历史记录
    // getSearchHistory(){
    //   this.$axios({
    //     method:"get",
    //     url:"/authorApi/z-user-image-search/getByUser",
    //   }).then((resultData)=>{
    //     resultData = resultData.data;
    //     if(resultData.status === 200){
    //       this.search_history = resultData.data;
    //       this.search_resultAreaShow = true;
    //       this.search_resultAreaHistoryShow = true;
    //       this.search_resultAreaAssociativeShow = false;
    //     }
    //     else{
    //       console.log(resultData.status + resultData.message);
    //     }
    //   }).catch((err)=>{
    //     console.log(err);
    //   });
    //
    // },
    //
    //
    //
    //
    // //搜索框获得焦点
    // searchInputFocus(){
    //   this.search_resultAreaShow = true;
    //   if(this.search_keyword != null && this.search_keyword !== ""){
    //     //旧的搜索记录不会变化
    //     this.search_resultAreaAssociativeShow = true;
    //     this.search_resultAreaHistoryShow = false;
    //   }
    //   else{
    //     //展示历史记录
    //     this.getSearchHistory();
    //   }
    //
    // },
    //
    // //搜索框失去焦点
    // searchInputBlur(){
    //   setTimeout(()=>{
    //     this.search_resultAreaShow = false;
    //   },200)
    // },
    //
    // //回车进行搜索
    // searchInputEnter(){
    //   document.querySelector("#keywordInputArea").blur()
    //   this.searchFun();
    //
    // },
    //
    // //点击搜索按钮进行搜索
    // searchBtnClick(){
    //   setTimeout(()=>{
    //     document.querySelector("#keywordInputArea").blur()
    //   },100)
    //   this.searchFun();
    // },
    //
    // //清空搜索框
    // clearSearchKeyword(){
    //   document.querySelector("#keywordInputArea").focus()
    //   this.search_keyword = '';
    //   console.log(this.step)
    //   if(this.step === 6){
    //     this.backSearchOldStep();
    //   }
    // },
    //
    //
    // //点击历史
    // clickSearchHistory(item){
    //   this.search_keyword = item;
    //   this.searchFun();
    //
    // },
    //
    // //点击联想词
    // clickSearchResult(item){
    //   this.search_keyword = item;
    //   this.searchFun();
    // },
    //
    //
    // //进行搜索(展示搜索中，搜索结果等)
    // searchFun(){
    //   if(this.step !== 6){
    //     //记录返回层
    //     this.search_oldStep = this.step;
    //   }
    //
    //   if(this.step !== 4){
    //     //不是在类别页
    //
    //     this.searching = true;
    //     this.step = 5;
    //
    //     this.$axios({
    //       method:"get",
    //       url:"/authorApi/z-image-collection/getListByKeyword",
    //       params:{
    //         keyWord:this.search_keyword
    //       }
    //     }).then((resultData)=>{
    //       resultData = resultData.data;
    //       if(resultData.status === 200){
    //         this.search_imageItemList = resultData.data;
    //         for(let i=0;i<this.search_imageItemList.length;i++){
    //           this.$set(this.search_imageItemList[i],"closeStatus",false)
    //         }
    //
    //         this.searching = false;
    //         this.step = 6;
    //
    //         let imageMarkerList = [];
    //         for(let i=0;i<this.search_imageItemList.length;i++){
    //           for(let j=0;j<this.search_imageItemList[i].zImageCollectionList.length;j++){
    //             imageMarkerList.push(this.search_imageItemList[i].zImageCollectionList[j])
    //           }
    //         }
    //         this.showImageMarker(imageMarkerList)
    //
    //         //可能处于预览状态
    //         this.$emit("quitPreviewLeftBar");
    //
    //         this.$parent.map.flyTo({
    //           center:this.$parent.initCenter,
    //           zoom:this.$parent.initZoom,
    //           bearing:0,
    //           pitch:0
    //         })
    //       }
    //       else{
    //         console.log(resultData.status + resultData.message);
    //       }
    //     }).catch((err)=>{
    //       console.log(err);
    //     });
    //   }
    //   else{
    //     //在类别页里搜索
    //     this.step4_currPageNum = 1;
    //     this.intoStep4(this.step4_type);
    //
    //   }
    //
    // },
    //
    //
    //
    // //清空历史记录
    // clearSearchHistory(){
    //   this.$axios({
    //     method:"get",
    //     url:"/authorApi/z-user-image-search/deleteUserSearch",
    //   }).then((resultData)=>{
    //     resultData = resultData.data;
    //     if(resultData.status === 200){
    //       //历史记录清空
    //       this.search_history = [];
    //     }
    //     else{
    //       console.log(resultData.status + resultData.message);
    //     }
    //   }).catch((err)=>{
    //     console.log(err);
    //   });
    // },
    //
    // //返回搜索上一层
    // backSearchOldStep(){
    //   this.step = this.search_oldStep;
    //   this.search_oldStep = 0;
    //
    //   //清除搜索输入
    //   this.searchKeywordChange_getHistory = false;   //仅清空输入，不展示历史
    //   this.search_keyword = '';
    //
    //   switch(this.step){
    //     case 1:{
    //       //第一层
    //       this.showFolderMarker(this.step1_imageFolderList,150);
    //       //可能处于预览状态
    //       this.$emit("quitPreviewLeftBar");
    //
    //       this.$parent.map.flyTo({
    //         center:this.$parent.initCenter,
    //         zoom:this.$parent.initZoom,
    //         bearing:0,
    //         pitch:0
    //       })
    //       break;
    //     }
    //     case 4:{
    //       //类别事件层
    //       this.showImageMarker(this.step4_imageItemList)
    //       //可能处于预览状态
    //       this.$emit("quitPreviewLeftBar");
    //
    //       this.$parent.map.flyTo({
    //         center:this.$parent.initCenter,
    //         zoom:this.$parent.initZoom,
    //         bearing:0,
    //         pitch:0
    //       })
    //       break;
    //     }
    //   }
    //
    //
    // },



    //在地图上展示影像集文件夹
    showFolderMarker(folderMarkerList,folderMarkerSize){
      this.$emit("showFolderMarker",JSON.stringify({
        folderMarkerList:folderMarkerList,
        folderMarkerSize:folderMarkerSize
      }))
    },
    //在地图上展示影像集文件夹
    showImageMarker(imageMarkerList){
      this.$emit("showImageMarker",imageMarkerList)
    },
    //在地图上展示影像集预览
    showImagePreview(imageId){
      this.$emit("showImagePreview",imageId);
    },



    //滚动条到底
    scrollToBottom(){
      if(this.step4_currPageNum < this.step4_totalPageNum){
        //还有下一页
        this.step4_currPageNum = this.step4_currPageNum + 1

        this.$axios({
          method:"get",
          url:"/authorApi/z-image-collection/getListByType",
          params:{
            type:this.step4_type.typeId,
            curPageNum:this.step4_currPageNum,
            maxResultNum:10
          }
        }).then((resultData)=>{
          resultData = resultData.data;
          if(resultData.status === 200){

            this.step4_imageItemList = this.step4_imageItemList.concat(resultData.data.list);
            this.step4_totalPageNum = resultData.data.totalPageNum

            this.$emit("addImageMarker",resultData.data.list)
          }
          else{
            console.log(resultData.status + resultData.message);
          }
        }).catch((err)=>{
          console.log(err);
        });
      }





    }


  },

  mounted(){

    this.getStepOneList();
    this.getStepOneImageTypeList();

    let temp = setInterval(()=>{
      if(this.$parent.mapboxInit && this.step1_imageFolderList.length !== 0){
        clearInterval(temp);
        this.showFolderMarker(this.step1_imageFolderList,130)
      }

    },100)

  },
  destroyed() {
    this.$emit("leftBarDestroy","imageLib")

  }


}
</script>


<style scoped>

.mainImageLib{
  height:100%;
  overflow:auto;
}


.domesticFolder{
  position:relative;
  width:308px;
  height:174px;
  border:1px solid #a6a6a6;
  border-radius:6px;
  background-size:cover;
  background-position: center;
  cursor:pointer;
}
.domesticFolder:hover{
  border:1px solid #ffffff;
}

.domesticFolderHoverShow{
  display:none;
}
.domesticFolder:hover .domesticFolderHoverShow{
  display:block;
}

/*hover蒙层出现动画*/
@keyframes domesticFolderHoverMantleShow {
  from {width:0;height:0;}
  to {width:100%;height:100%;}
}
.domesticFolderHoverMantle{
  animation: domesticFolderHoverMantleShow 0.03s linear;
}


.domesticFolder-title{
  position:absolute;
  top:5px;
  left:10px;
  width:calc(100% - 20px);
  font-size:16px;
  color:#ffffff;
  font-weight:bold;
  text-shadow: -1px 1px 0 #000, 1px 1px 0 #000, 1px -1px 0 #000,-1px -1px 0 #000;
}


</style>


<style>

#keywordInputArea{
  margin-right:40px;
}

</style>